<app-navbar-control></app-navbar-control>

<div class="pb-5" style="height: 100%; overflow-y: auto;">
    <div [innerHTML]="terms"></div>
</div>